import { render, staticRenderFns } from "./select-double.vue?vue&type=template&id=49ca9bfc"
import script from "./select-double.vue?vue&type=script&lang=js"
export * from "./select-double.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports